// lib
import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
// src
import { updateFocusAndFetch } from "actions/events/thunks";

const DateHeader = ({ date, label }) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(updateFocusAndFetch(date.getTime()));
  };
  return (
    <div role="button" onClick={handleClick}>
      {label}
    </div>
  );
};

DateHeader.propTypes = {
  label: PropTypes.node,
  date: PropTypes.instanceOf(Date),
};
DateHeader.defaultProps = {
  label: null,
  date: Date.now(),
};

export default DateHeader;
